<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.suratKonfirmasi }}</strong>
          </p>
        </template>
        <CRow>
          <CCol>
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #tglDibuat-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalDibuatSurat" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #tglDibalas-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalDibalasSurat" format="DD MMMM YYYY"></date-picker>
              </template>
              <template #statusnya-filter>
                <b-form-select v-model="filter.statusKonfirmasi" :options="optionsStatusKonfirmasi"></b-form-select>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button variant="secondary" class="mr-1" v-c-tooltip.hover.click="'Print Surat'" v-b-modal.modal-print @click="setPrint(item)">
                    <CIcon name="cil-print" />
                  </b-button>
                  <b-button variant="primary" class="mr-1" v-c-tooltip.hover.click="'Kirim Surat'" @click="changeStatus(item)">
                    <CIcon name="cil-print" />
                  </b-button>
                  <b-button v-if="item.statusKonfirmasi != 0" variant="warning" class="mr-1" v-c-tooltip.hover.click="'Edit Data'" v-b-modal.modal-edit @click="data = item">
                    <CIcon name="cil-pencil" />
                  </b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-edit :data="data" @alertFromChild="triggerAlert($event)" />
    <modal-print :printData="printData" />
  </CRow>
</template>

<script>
import ModalEdit from "./modalEdit.vue";
import ModalPrint from "./modalPrint.vue";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/id";
export default {
  components: {
    ModalEdit,
    ModalPrint,

    DatePicker,
  },
  name: "suratKonfirmasi",
  data() {
    return {
      printData: null,
      data: {},
      items: [],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          class: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "nomorSuratKonfirmasi",
          label: "No. Surat Konfirmasi",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: "Nama",
          _style: "width: 20%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "statusnya",
          label: "Status",
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "tglDibuat",
          label: "Tanggal Surat Dibuat",
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "tglDibalas",
          label: "Tanggal Surat Dibalas",
          _style: "width: 15%;",
          sortDirection: "desc",
          class: "text-left",
          sorter: false,
        },
        {
          key: "Actions",
          label: "Actions",
          class: "table-option-2 text-center",
          _style: "width: 15%;",
          filter: false,
          sorter: false,
        },
      ],
      filter: {
        tanggalDibuatSurat: null,
        tanggalDibalasSurat: null,
        statusKonfirmasi: null,
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsStatusKonfirmasi: [
        { value: null, text: "Pilih" },
        { value: "0", text: "Belum Dikirim" },
        { value: "1", text: "Dikirim (Belum Dibalas)" },
        { value: "2", text: "Sudah Dibalas" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
  },
  mounted() {
    this.getDatas();
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalDibuatSurat"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalDibalasSurat"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.statusKonfirmasi"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = x;
      vm.currentPage = 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listSuratKonfirmasi = await vm.$axios.post("/suratKonfirmasi/listPerHalaman", {
        ...vm.filter,
        tanggalDibuatSurat: vm.filter.tanggalDibuatSurat ? vm.$moment(vm.filter.tanggalDibuatSurat).format("YYYY-MM-DD") : null,
        tanggalDibalasSurat: vm.filter.tanggalDibalasSurat ? vm.$moment(vm.filter.tanggalDibalasSurat).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
      });
      console.log("listSuratKonfirmasi", listSuratKonfirmasi);
      vm.items =
        listSuratKonfirmasi.data.status == 200
          ? listSuratKonfirmasi.data.data.map((x, idx) => {
              if (x.statusKonfirmasi == 0) {
                x.statusnya = "Belum Dikirim";
              } else if (x.statusKonfirmasi == 1) {
                x.statusnya = "Dikirim (Belum Dibalas)";
              } else if (x.statusKonfirmasi == 2) {
                x.statusnya = "Sudah Dibalas";
              }
              x.tglDibuat = vm.$moment(x.tanggalDibuatSurat).format("LL");
              x.tglDibalas = x.tanggalDibalasSurat ? vm.$moment(x.tanggalDibalasSurat).format("LL") : "";
              return {
                ...x,
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
              };
            })
          : [];
      vm.totalRows = parseInt(listSuratKonfirmasi.data.count);
      vm.loading = false;
    },
    changeStatus(x) {
      let vm = this;
      // console.log(x);
      let data = {};
      data.id = x.suratKonfirmasiId;
      data.statusKonfirmasi = 1;
      vm.$axios
        .post("suratKonfirmasi/update", data)
        .then((res) => {
          console.log(res, "ini ress");
          if (res.data.message == "sukses") {
            vm.variant = "success";
            vm.msg = "BERHASIL MENGIRIM SURAT KONFIRMASI";
            vm.showing = true;
          } else {
            vm.variant = "danger";
            vm.msg = res.data.message.toUpperCase();
            vm.showing = true;
          }
        })
        .catch((err) => {
          err;
          // console.log(err);
          vm.variant = "danger";
          vm.msg = "TERJADI KESALAHAN PADA SERVER";
          vm.showing = true;
          setTimeout(() => {
            vm.showing = false;
          }, 4000);
        });
    },
    print(data) {
      window.open(this.$be + "poolKontrak/cetakSuratPerintah/" + data.poolKontrakId, "_blank");
    },
    async setPrint(x) {
      console.log(x, "ini x");
      let vm = this;
      let printdata = await vm.$axios.get("poolKontrak/pengantarYBS/" + x.dataKaryawanId);
      // console.log(printdata.data.data, "ini konfirmasinya boss");
      vm.printData = printdata.data.data[0];
      vm.printData.tanggal = vm.$moment().format("LL");
      vm.printData.tanggalLahirKaryawanPrint = vm.$moment(vm.printData.tanggalLahirKaryawan).format("LL");
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>
